import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import LoginModal from "./Login";
import Register from "./Register";
import "./Navbar.css";
import image from '../../src/image/main-logo.png';  
import { CiMenuBurger } from "react-icons/ci";
import { IoIosCloseCircle } from "react-icons/io";



const API = "https://course-selling-backend-2-rr1n.onrender.com";

const NavLink = ({ children, href = "#" }) => (
  <a className="mh-navlink" href={href}>
    {children}
  </a>
);



export default function Navbar({ logoSrc = "/logo-medby.svg" }) {
  const [open, setOpen] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const [isRegisterOpen, setIsRegisterOpen] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);


  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    setIsAuthenticated(!!token);

    if (token) {
      axios
        .get(`${API}/api/users/me`, {
          headers: { "x-auth-token": token },
        })
        .catch(() => setIsAuthenticated(false));
    }
  }, []);

  const handleDashboardClick = () => {
    if (isAuthenticated) {
      navigate("/dashboard");
    } else {
      alert("⚠️ Pehle register/login karo, tabhi dashboard access kar sakte ho.");
      navigate("/login");
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    setShowAlert(true);

    setTimeout(() => {
      setShowAlert(false);
      setIsAuthenticated(false);
      navigate("");
      window.location.href = "#home"; // redirect
    }, 2000);
  };

  return (
    <header className="mh-header">
      {/* nav */}
      <div className="mh-sticky">
        <div className="mh-container mh-nav">
          <div className="mh-brand">
            <img src={image} alt="Medby Academy" className="mh-logo" onError={(e) => { e.currentTarget.style.display = "none"; }} />
          </div>
          <nav className="mh-dropdown-btn-home">
            <NavLink href="/">HOME</NavLink>
            <div
              className="mh-dropdown"
              onMouseEnter={() => setShowDropdown(true)}
              onMouseLeave={() => setShowDropdown(false)}
            >
               <NavLink href="/Certificate_Courses">COURSES</NavLink>
            {/*   <button className="mh-dropdown-btn" >COURSES ▾</button>

              {showDropdown && (
                <div className="mh-dropdown-content">
                 <a href="/Fellowship_Courses">Fellowship Courses</a>
                  <a href="/Certificate_Courses">Certificate Courses</a>  
                </div>
              )}*/ }
            </div>


            {!isAuthenticated ? (
              <>
                <button
                  className="modern-btn"
                  onClick={() => setIsLoginOpen(true)}
                >
                  Login
                </button>
                <LoginModal
                  isOpen={isLoginOpen}
                  onClose={() => setIsLoginOpen(false)}
                />

                <button
                  className="modern-btn"
                  onClick={() => setIsRegisterOpen(true)}
                >
                  Register
                </button>
                <Register
                  isOpen={isRegisterOpen}
                  onClose={() => setIsRegisterOpen(false)}
                />
               
              </>
            ) : (
              <>
                <button
                  className="modern-btn"
                  onClick={handleDashboardClick}
                >
                  Dashboard
                </button>
                <button className="modern-btn" onClick={handleLogout}>
                  Logout
                </button>
                {showAlert && (
                  <div className="custom-alert">
                    <p>You have been logged out successfully!</p>
                  </div>
                )}
              </>
            )}
          </nav>

          <button className="mh-menu-btn" aria-label="Open menu" onClick={() => setOpen(true)}>
            <CiMenuBurger />
          </button>
        </div>

        {/* mobile drawer */}
        {open && (
          <div className="mh-drawer" role="dialog" aria-modal="true">
            <div className="mh-drawer-backdrop" onClick={() => setOpen(false)} />
            <div className="mh-drawer-panel">
              <div className="mh-drawer-head">
                <button onClick={() => setOpen(false)} className="mh-close-btn"><IoIosCloseCircle /></button>
              </div>
              <div className="mh-drawer-links">
                <a href="/" onClick={() => setOpen(false)}>HOME</a>
                <a href="/courses" onClick={() => setOpen(false)}>COURSES</a>
                <a href="/about" onClick={() => setOpen(false)}>ABOUT US</a>
                <a href="/contact" onClick={() => setOpen(false)}>CONTACT US</a>


                {!isAuthenticated ? (
                  <>
                    <button
                      className="modern-btn"
                      onClick={() => setIsLoginOpen(true)}
                    >
                      Login
                    </button>
                    <LoginModal
                      isOpen={isLoginOpen}
                      onClose={() => setIsLoginOpen(false)}
                    />

                    <button
                      className="modern-btn"
                      onClick={() => setIsRegisterOpen(true)}
                    >
                      Register
                    </button>
                    <Register
                      isOpen={isRegisterOpen}
                      onClose={() => setIsRegisterOpen(false)}
                    />
                  </>
                ) : (
                  <>
                    <button
                      className="modern-btn"
                      onClick={handleDashboardClick}
                    >
                      Dashboard
                    </button>
                    <button className="modern-btn" onClick={handleLogout}>
                      Logout
                    </button>
                    {showAlert && (
                      <div className="custom-alert">
                        <p>You have been logged out successfully!</p>
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
